import { HttpErrorResponse } from '@angular/common/http';
import { delay, Observable, of, RetryConfig } from 'rxjs';

export const RETRY_INTERVAL_MULTIPLIER = 1000;

export function createRetryConfig(
  count: number,
  errorCodes: string[] = [],
  interval = RETRY_INTERVAL_MULTIPLIER
): RetryConfig {
  return {
    count,
    delay: (error, retryCount): Observable<HttpErrorResponse | undefined> => {
      const { errorCode } = error.error;
      const numericErrorCode = (errorCode as string).split('-')[1];
      const numericErrorCodes = errorCodes.map((code: string) => code.split('-')[1]);
      const errorCodeMatches = numericErrorCodes.some(code => code.endsWith(numericErrorCode));

      if (
        error instanceof HttpErrorResponse &&
        (!numericErrorCodes.length || (numericErrorCodes.length && errorCodeMatches))
      ) {
        return of(error).pipe(delay(retryCount * interval));
      }
      throw error;
    },
  };
}
